import dataExplorer from './DataExplorer';
import schemaExplorer from './SchemaExplorer';

const dbServiceReducers = () => ({
  schemaExplorer,
  dataExplorer
});

export default dbServiceReducers;
